/**
 * @format
 * @flow
 */
import * as App from '../constants/reducers/App';
import axios from 'axios';
import * as Api from '../constants/Api';

export const getNotification = (enterpriseId, token) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getNotificationApi,
        {
          code: 'get_notification',
          enterpriseId
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, '取得エラー'));
        } else {
          dispatch(displayNotification(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(err => {
        dispatch(loadEnd());
      });
  };
};

export const updateNotification = (enterpriseId, notificationId, token) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getNotificationApi,
        {
          code: 'update_notification',
          enterpriseId,
          notificationId
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, '取得エラー'));
        } else {
          dispatch(displayNotification(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(err => {
        dispatch(loadEnd());
      });
  };
};

export const displayNotification = data => {
  return {
    type: App.SET_NOTIFICATION_DATA,
    data
  };
};

export function loadStart() {
  return {
    type: App.LOAD_START
  };
}

export function loadEnd() {
  return {
    type: App.LOAD_END
  };
}

export const modalOpen = (text, title = '') => {
  return {
    type: App.MODAL_CHANGE,
    modalOpen: true,
    modalText: text,
    modalTitle: title
  };
};

export const modalClose = () => {
  return {
    type: App.MODAL_CHANGE,
    modalOpen: false,
    modalText: '',
    modalTitle: ''
  };
};

export const errorShow = text => {
  return {
    type: App.ERROR_SHOW,
    errorShow: true,
    errMsg: text
  };
};

export const errorReset = text => {
  return {
    type: App.ERROR_SHOW,
    errorShow: false,
    errMsg: ''
  };
};

export const errorClose = () => {
  return {
    type: App.ERROR_SHOW,
    errorShow: false
  };
};
